import { productCategoriesStyles } from "@ces/App/Widgets/ProductCategories/ProductCategories";
import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { color } from "@ces/XDL/Utilities";
import { GridWrapper } from "@insite/mobius/GridContainer";
import { css } from "styled-components";

productCategoriesStyles.categoryWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
        align-items: center;
    `,
};

productCategoriesStyles.imageWrapper = {
    css: css`
        align-items: center;
        justify-content: center;
        padding: 0 8px;
    `,
};

productCategoriesStyles.image = {
    css: css`
        border-radius: 50%;
        border: 1px solid ${color("common.ui4")};
    `,
};

productCategoriesStyles.link = {
    color: "text",
    typographyProps: {
        size: 14,
        lineHeight: "22px",
        weight: fontConfig.weight.bold,
        css: css`
            text-align: center;
        `,
    },
    css: css`
        text-align: center;
    `,
};

productCategoriesStyles.centeringWrapper = {
    css: css`
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

productCategoriesStyles.swiperStyles = {
    container: {
        css: css`
            .xng-pagination-container > .swiper-scrollbar.swiper-scrollbar-horizontal {
                background: ${color("common.ui1")};
            }

            .swiper-slide > ${GridWrapper} {
                display: flex;
                flex: 1;
                height: 100%;
                flex-wrap: nowrap;
            }
        `,
    },
};
